import '../css/ReportFooter.less';

import React from 'react';
import {Link} from 'react-router-dom';
import {signup, login} from '../util/urls';
import {useViewer} from '../state/viewer/hooks';
import makeComp from '../util/profiler';

const ReportFooter: React.FC = makeComp(
  () => {
    const viewer = useViewer();
    if (viewer) {
      return <></>;
    }
    return (
      <div className="report-footer">
        <div className="divider" />
        <div className="cta">
          Made with Weights &amp; Biases.{' '}
          <Link to={signup()} className="footer-link">
            Sign up
          </Link>{' '}
          or{' '}
          <Link to={login()} className="footer-link">
            log in
          </Link>{' '}
          to create reports like this one.
        </div>
      </div>
    );
  },
  {id: 'ReportFooter'}
);

export default ReportFooter;
